import React, { useEffect, useState } from "react";
import styles from "./RecentPosts.module.css";
import { Input } from "antd";
import { useNavigate } from "react-router-dom";

const RecentPosts = ({ list, background, searchColor, textColor }) => {
  const navigate = useNavigate();

  const postdata = [
    {
      content: "Rebooting the bodyshop after the mega lock-down!",
      img: "/img/bodyshop/about-us-one.png",
    },
    {
      content: "Rebooting the bodyshop after the mega lock-down!",
      img: "/img/bodyshop/about-us-two.png",
    },
    {
      content: "Rebooting the bodyshop after the mega lock-down!",
      img: "/img/bodyshop/about-us-three.png",
    },
  ];

  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    setSearchData(list);
  }, [list]);

  const scrollToTop = () => {
    document.documentElement.scrollTop = 0; // For most browsers
    document.body.scrollTop = 0; // For Safari compatibility
  };

  return (
    <div className={styles.container} style={{ backgroundColor: background }}>
      <div className={styles.searchBar}>
        <Input
          placeholder="Looking for...."
          className={styles.placeholder}
          onChange={(e) => {
            setSearchData(
              list.filter((item) =>
                item.name
                  .toLocaleLowerCase()
                  .includes(e.target.value.toLocaleLowerCase())
              )
            );
          }}
        ></Input>
        <img
          loading="lazy"
          src="/img/bodyshop/search-icon.svg"
          className={styles.searchIcon}
          alt="Search"
        />
      </div>
      <h2 className={styles.recentPostsTitle} style={{ color: textColor }}>
        Recent Posts
      </h2>
      {searchData?.slice(0, 3)?.map((item) => (
        <div data-aos="fade" data-aos-delay="200"
          className={styles.postItem}
          onClick={() => {
            scrollToTop();
            navigate(`/reviews-and-blogs/${item?.slug}`);
          }}
        >
          <img
            loading="lazy"
            src={item.image}
            className={styles.postImage}
            alt="Post thumbnail"
          />
          <div className={styles.postTitle} style={{ color: textColor }}>
            {item.name}
          </div>
        </div>
      ))}
      {searchData?.length == 0 && (
        <p className={styles.noPost}>No Post Available...</p>
      )}
    </div>
  );
};

export default RecentPosts;
